import {AfterContentInit, AfterViewInit, Component, ContentChildren, QueryList, ViewChildren} from "@angular/core";
import {SelectOptionComponent} from "./select-option.component";
import {forkJoin, map, ReplaySubject, Subscription} from "rxjs";
import {TranslateService} from "@ngx-translate/core";

@Component({
    selector: "wbo-select-options",
    template: "<ng-content></ng-content>"
})
export class SelectOptionsComponent implements AfterContentInit, AfterViewInit {
    @ContentChildren(SelectOptionComponent) contentOptions: QueryList<SelectOptionComponent>;
    @ViewChildren(SelectOptionComponent) viewOptions: QueryList<SelectOptionComponent>;

    public data$: ReplaySubject<{ label: string, value: any }[]> = new ReplaySubject<{
        label: string,
        value: any
    }[]>(1);

    optionsSubscription: Subscription = new Subscription();

    constructor(private translateService: TranslateService) {
    }

    ngAfterContentInit(): void {
        this.refreshData();
        this.contentOptions.changes.subscribe(() => this.refreshData());
    }

    ngAfterViewInit(): void {
        this.refreshData();
        this.viewOptions.changes.subscribe(() => this.refreshData());
    }

    refreshData(): void {
        if (this.contentOptions && this.viewOptions) {
            this.optionsSubscription.unsubscribe();
            this.optionsSubscription = new Subscription();
            this.contentOptions.toArray().concat(this.viewOptions.toArray()).forEach((option: SelectOptionComponent) => {
                this.optionsSubscription.add(option.dataChanged.subscribe(() => {
                    this.refreshData();
                }));
            });
            forkJoin(
                this.contentOptions.toArray().concat(this.viewOptions.toArray())
                    .map(option => this.translateService.get(option.label, option.labelParams).pipe(
                        map(translation => ({
                            "label": translation,
                            "value": option.value === undefined ? translation : option.value
                        }))
                    ))
            ).subscribe(results => {
                setTimeout(() => this.data$.next(results));
            });
        }
    }
}



